import React from 'react'
import './distribute.css';

const Distribute = () => {
  return (
    <div>Distribute</div>
  )
}

export default Distribute